import { Component, OnInit, Input } from '@angular/core';
import { Step } from '../../interfaces/step.interface';

@Component({
    selector: 'roblex-step',
    templateUrl: './step.component.html',
    styleUrls: ['./step.component.scss'],
})
export class StepComponent implements OnInit {
    @Input() steps!: Step[];
    @Input() current!: number;
    constructor() {}

    ngOnInit(): void {}
}
